/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {routes as ɵa} from './app/app.routes';